import {publishTrackEvent} from "../.."

const TrackInjectedAdClick = (creativeId: number, uniqueId: string, placementId: number) => {
    publishTrackEvent("osaEvent", {
        eventCat: "osa",
        eventAct: "osa banner click",
        creativeId,
        uniqueId,
        placementId,
    })
}

export default TrackInjectedAdClick
